export default "__VITE_ASSET__BC59Tl28__"